<div class="graphics-panel">
  <!-- Tab strip: Elements | From MAM (only when not in editor) -->
  @if (!selectedGraphic() && !selectedMamInstanceForEdit()) {
    <div class="graphics-panel__tabs">
      <button
        type="button"
        class="graphics-panel__tab"
        [class.graphics-panel__tab--active]="sourceTab() === 'elements'"
        (click)="setSourceTab('elements')"
      >
        Elements
      </button>
      <button
        type="button"
        class="graphics-panel__tab"
        [class.graphics-panel__tab--active]="sourceTab() === 'mam'"
        (click)="setSourceTab('mam')"
      >
        Add from MAM
      </button>
    </div>

    <!-- Elements: catalog view -->
    @if (sourceTab() === 'elements') {
      <div class="graphics-panel__header">
        <div class="graphics-panel__search-wrapper">
          <ichannel-input
            [placeholder]="'Search elements...'"
            [value]="searchTerm()"
            (valueChange)="onSearchTermChange($event)"
          ></ichannel-input>
          @if (searchTerm()) {
            <button type="button" class="graphics-panel__search-clear" (click)="clearSearch()" aria-label="Clear search">
              &times;
            </button>
          }
        </div>
      </div>

      <!-- Error message (same style as find-clip-panel in Clipping Studio) -->
      @if (elementsCatalogError()) {
        <div class="graphics-panel__section graphics-panel__error">
          <p class="graphics-panel__error-text">{{ elementsCatalogError() }}</p>
        </div>
      }

      @if (elementsCatalogLoading()) {
        <p class="graphics-panel__message">Loading…</p>
      }
      @if (!elementsCatalogLoading()) {
        @if (filteredItems().length > 0) {
          <div class="graphics-panel__grid">
            @for (item of filteredItems(); track item.id) {
              <evrideo-clipping-studio-graphic-card
                [item]="item"
                [isEditMode]="isEditMode()"
                (add)="onAddGraphic($event)"
              ></evrideo-clipping-studio-graphic-card>
            }
          </div>
        }
        @if (filteredItems().length === 0) {
          <div class="graphics-panel__empty">
            <span class="graphics-panel__empty-text">No elements found</span>
          </div>
        }
      }
    }

    <!-- Add from MAM: Scheduler-like templates with expandable instances -->
    @if (sourceTab() === 'mam') {
      <div class="graphics-panel__header">
        <div class="graphics-panel__search-wrapper">
        <ichannel-input
          [placeholder]="'Search in MAM…'"
          [value]="mamSearchTerm()"
          (valueChange)="onMamSearchTermChange($event)"
        ></ichannel-input>
          @if (mamSearchTerm()) {
            <button type="button" class="graphics-panel__search-clear" (click)="clearMamSearch()" aria-label="Clear search">
              &times;
            </button>
          }
        </div>
      </div>

      @if (mamGraphicsTemplates().length > 0) {
        <div class="graphics-panel__mam-list">
          <ng-template
            ngFor
            let-index="index"
            let-item
            [ngForOf]="mamGraphicsTemplates()"
          >
            <div class="graphics-panel__mam-template" (click)="onMamInstancesClick(index)">
              <evrideo-clipping-studio-mam-graphic-card
                [item]="item"
              ></evrideo-clipping-studio-mam-graphic-card>
            </div>

            <div
              class="graphics-panel__instances-container"
              [class.show]="currentMamGraphicsTemplateIndex === index"
            >
              <div class="graphics-panel__instances-header">
                <span>
                  {{ getCurrentMamGraphicsTemplate()?.title?.toUpperCase() }} INSTANCES:
                </span>
                <button type="button" (click)="onMamInstancesClick(null)">
                  Close
                </button>
              </div>

              <div class="graphics-panel__instances-list">
                @for (graphicItem of getCurrentMamGraphicsInstances(); track graphicItem.id) {
                  <evrideo-clipping-studio-mam-graphic-card
                    [item]="graphicItem"
                    [showEditOverlay]="true"
                    (edit)="openMamInstanceEditor(graphicItem)"
                  ></evrideo-clipping-studio-mam-graphic-card>
                }
              </div>
            </div>
          </ng-template>
        </div>
      }
      @if (mamGraphicsTemplates().length === 0 && !mamLoading()) {
        <div class="graphics-panel__empty">
          <span class="graphics-panel__empty-text">No matches found</span>
        </div>
      }
    }
  }

  @if (selectedMamInstanceForEdit() || selectedGfxTimelineGraphic()) {
    <div class="graphics-panel__mam-editor">
      <div class="graphics-panel__mam-editor-header">
        <h3 class="graphics-panel__mam-editor-title">Edit</h3>
        <button
          type="button"
          class="graphics-panel__mam-editor-close-btn"
          (click)="onCloseGfxParamsEditorShell()"
          aria-label="Close"
        >
          &times;
        </button>
      </div>
      <div class="graphics-panel__mam-editor-body">
        @if (activeGfxParamsLoading()) {
          <p class="graphics-panel__mam-editor-message">Loading parameters...</p>
        }
        @if (activeGfxParamsError(); as err) {
          <p class="graphics-panel__mam-editor-error">{{ err }}</p>
        }
        @if (!activeGfxParamsLoading() && !activeGfxParamsError() && activeGfxParamsGraphicsInfo(); as editorInfo) {
          <div class="graphics-panel__mam-editor-fields">
            <evrideo-clipping-studio-mam-graphic-params-editor
              [graphicsInfo]="editorInfo"
              (paramsChange)="onGfxParamsFieldsChange()"
            ></evrideo-clipping-studio-mam-graphic-params-editor>
          </div>
        }
      </div>
      <div class="graphics-panel__mam-editor-footer">
        @if (selectedMamInstanceForEdit()) {
          <button
            type="button"
            class="graphics-panel__mam-editor-add-btn"
            (click)="onAddGfxToTimeline()"
            [disabled]="
              !isEditMode() ||
              activeGfxParamsLoading() ||
              activeGfxParamsMaterializeLoading() ||
              !activeGfxParamsMaterializeReady()
            "
          >
            Add to timeline
          </button>
          <button
            type="button"
            class="graphics-panel__mam-editor-cancel-btn"
            (click)="closeMamInstanceEditor()"
          >
            Cancel
          </button>
        }
        @if (selectedGfxTimelineGraphic()) {
          <button
            type="button"
            class="graphics-panel__mam-editor-add-btn"
            (click)="onSaveTimelineGfxChanges()"
            [disabled]="
              !isEditMode() ||
              activeGfxParamsLoading() ||
              activeGfxParamsMaterializeLoading() ||
              !activeGfxParamsMaterializeReady()
            "
          >
            Save Changes
          </button>
          <button
            type="button"
            class="graphics-panel__mam-editor-cancel-btn"
            (click)="onCloseGfxParamsEditorShell()"
          >
            Cancel
          </button>
        }
      </div>
    </div>
  }

  <!-- Editor view: logo / fruit-icon / emoji; GFX uses MAM params shell above -->
  @if (selectedGraphic(); as graphic) {
    @if (graphic.type !== 'gfx') {
    @if (graphic.type === 'logo') {
      <evrideo-clipping-studio-logo-editor
        [graphic]="graphic"
        [isEditMode]="isEditMode()"
        [currentTimeMs]="state().currentTimeMs ?? 0"
        [fps]="state().media?.fps ?? 30"
        (previewChange)="onPreviewGraphicChange($event)"
        (update)="onUpdateGraphic($event)"
        (close)="onCloseEditor($event)"
      ></evrideo-clipping-studio-logo-editor>
    }
    @if (graphic.type === 'fruit-icon') {
      <evrideo-clipping-studio-fruit-icon-editor
        [graphic]="graphic"
        [isEditMode]="isEditMode()"
        [currentTimeMs]="state().currentTimeMs ?? 0"
        [fps]="state().media?.fps ?? 30"
        (previewChange)="onPreviewGraphicChange($event)"
        (update)="onUpdateGraphic($event)"
        (close)="onCloseEditor($event)"
      ></evrideo-clipping-studio-fruit-icon-editor>
    }
    @if (graphic.type === 'emoji') {
      <evrideo-clipping-studio-emoji-editor
        [graphic]="graphic"
        [isEditMode]="isEditMode()"
        [currentTimeMs]="state().currentTimeMs ?? 0"
        [fps]="state().media?.fps ?? 30"
        (previewChange)="onPreviewGraphicChange($event)"
        (update)="onUpdateGraphic($event)"
        (close)="onCloseEditor($event)"
      ></evrideo-clipping-studio-emoji-editor>
    }
    }
  }
</div>
